import { FC, memo } from "react";
import classificationByLabels, {
  getClassificationByLabels
} from "../lib/enums/ThreatStatusEnum";
import NoData from "./NoData";

type Props = {
  status: string;
  name: string;
};

const ThreatName: FC<Props> = ({ status, name }) => {
  const showThreatName = [
    classificationByLabels.SUSPICIOUS,
    classificationByLabels.MALICIOUS
  ].includes(getClassificationByLabels(status));

  if (!showThreatName) {
    return <NoData />;
  }

  return <span>{name}</span>;
};

export default memo(ThreatName);
